import { Routes } from '@angular/router';

// dashboard
import { AppLayout } from './layouts/app-layout/app-layout';
import { AuthLayout } from './layouts/auth-layout/auth-layout';
import { AuthRedirectGuard } from './core/guards/auth-redirect.guard';
import { AuthGuard } from './core/guards/auth.guard';

export const routes: Routes = [
    {
        path: '',
        component: AuthLayout,
        loadChildren: () => import('./auth/auth.routes').then((m) => m.authRoutes),
        canActivate: [AuthRedirectGuard],
    },
    {
        path: '',
        component: AppLayout,
        loadChildren: () => import('./pages/pages.route').then((m) => m.PageRouting),
        canActivate: [AuthGuard],
    },
    {
        path: '**',
        redirectTo: '',
    },
];
